import { FunctionComponent, ReactElement } from 'react';
import { Box, IconButton, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { formatBytes } from '@/shared/utils/file';
import { FileStatus } from './types';

interface FileUploadedProps {
	file: File;
	status?: FileStatus;
	onRemove: () => void;
}

const FileUploaded: FunctionComponent<FileUploadedProps> = ({
	file,
	status,
	onRemove,
}): ReactElement => (
	<Box component={Paper} padding={2}>
		<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
			<Stack direction="column">
				<Typography variant="body1">{file.name}</Typography>
				<Stack direction="column" spacing={0.5} width={'200px'}>
					<Stack direction="row" spacing={1} color="text.secondary">
						<Typography variant="body2">{formatBytes(file.size)}</Typography>
						<Typography variant="body2">&bull;</Typography>
						<Typography variant="body2">
							{status === FileStatus.LOADING ? 'Loading' : 'Loaded'}
						</Typography>
					</Stack>

					<LinearProgress
						value={status === FileStatus.LOADED ? 100 : undefined}
						variant={status === FileStatus.LOADED ? 'determinate' : 'indeterminate'}
					/>
				</Stack>
			</Stack>
			<Box component={IconButton} padding={1.5} onClick={onRemove}>
				<CloseRounded />
			</Box>
		</Stack>
	</Box>
);

export default FileUploaded;
